import React from 'react'
import { useState } from 'react';
import logoUrl from '../../assets/logos/reply-logo-white.svg';

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false)

    const menuListClass = "text-brand-white font-mono uppercase font-semibold hover:text-brand-blue duration-300 py-1 px-1 gap-4 sm:gap-0"
    const mobileMenuStyle = `fixed lg:hidden w-screen left-0 top-0 bg-brand-black z-0 top-16 px-6 md:px-8 overflow-y-hidden transition-[max-height,padding] duration-200 z-[99] ease-in ${menuOpen ? "max-h-full py-6" : "max-h-0 py-0"}`
    return (
    <>
    <nav className='w-full h-16 bg-brand-black flex items-center justify-between px-6 md:px-8 xl:px-[8vw] fixed top-0 z-[99]'>
        <div className='flex h-full relative items-center gap-2'>
            <h3 className='text-lg text-brand-white font-display font-black uppercase  leading-[.82] tracking-tight text-[clamp(3.4rem,13.5vw,12.5rem)'>Student Tech <b className='text-brand-blue'>Clash</b></h3>
            <span className='text-lg text-brand-white font-mono font-black ml-2 hidden sm:block'>x</span>
            <img src={logoUrl} alt="reply-logo" className='h-12 translate-y-[2px]'/>
        </div>
        
        <ul className='items-center justify-end gap-6 hidden lg:flex'>
            <li><a href="#evento" className={menuListClass}>Event</a></li>
            <li><a href="#format" className={menuListClass}>Format</a></li>
            {/*<li><a href="#premi" className={menuListClass}>Prizes</a></li>*/}
            <li><a href="#programma" className={menuListClass}>Schedule</a></li>
            <li><a href="#contatti" className={menuListClass}>Contacts</a></li>
            <li>
                
                    <button className='blue-btn'> 
                        <a href="#iscriviti">[ Register ] </a>
                    </button>
                
            </li>
        </ul>

        <button className='transparent-btn lg:hidden' onClick={()=>{setMenuOpen(!menuOpen)}}>
            MENU
        </button>
    </nav>

    <section className={mobileMenuStyle}>
            <ul className='flex flex-col gap-6'>
                <li><a href="#evento" className={menuListClass}>Event</a></li>
                <li><a href="#format" className={menuListClass}>Format</a></li>
                {/*<li><a href="#premi" className={menuListClass}>Prizes</a></li> */}
                <li><a href="#programma" className={menuListClass}>Schedule</a></li>
                <li><a href="#contatti" className={menuListClass}>Contacts</a></li>
                <li>
                    <a href="#iscriviti">
                        <button className='blue-btn'> 
                            [ Register ] 
                        </button>
                    </a>
                </li>
            </ul>
        </section>
    </>

  )
}

export default Navbar